import {
  //   SET_ERRORS,
  //   CLEAR_ERRORS,
  //   LOADING_UI,
  LOADING_IMAGE,
  UPLOAD_SCREAM,
} from "../types";

const initialState = {
  load: false,
  errors: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case SET_ERRORS:
    //   return {
    //     ...state,
    //     loading: false,
    //     errors: action.payload,
    //   };
    // case CLEAR_ERRORS:
    //   return {
    //     ...state,
    //     loading: false,
    //     errors: null,
    //   };
    // case LOADING_UI:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    case LOADING_IMAGE:
      return {
        ...state,
        load: true,
      };
    case UPLOAD_SCREAM:
      return {
        ...state,
        load: false,
      };
    default:
      return state;
  }
}
